import { motion } from "framer-motion"
import type { ReactNode } from "react"
import { fadeUp } from "@/shared/lib/motion"

interface PageTransitionProps {
	children: ReactNode
}

/**
 * Обёртка содержимого страницы: появление и уход при смене маршрута.
 *
 * Скролл здесь намеренно не трогаем: им занимается `widgets/app-layout`,
 * который умеет ещё и восстанавливать позицию при возврате назад. Раньше
 * сброс стоял в обоих местах, и при back-навигации они спорили друг с другом.
 */
export function PageTransition({ children }: PageTransitionProps) {
	return (
		<motion.div variants={fadeUp} initial="hidden" animate="visible" exit="exit">
			{children}
		</motion.div>
	)
}
